import shopifyGenericDefaults from '../shopify-generic/config.js';

shopifyGenericDefaults.Widgets.map((w) => {
  if (w.name === 'FilterChips' || w.name === 'Facets' || w.name === 'FacetDialog') {
    if (w.ignoreFields) {
      w.ignoreFields.push('wheel_tire_diameter');
    } else {
      w.ignoreFields = ['wheel_tire_diameter'];
    }
  }
  return w;
});

window.Convermax.getWheelBadgeUrl = (badge, wheelId) => {
  const rootRoute = window.Convermax.Shopify.getRootRoute();

  if (badge === 'Hub Rings Required') {
    return `${rootRoute}/collections/hub-rings?WheelID/${wheelId}`;
  }

  if (badge === 'Spline Lug Nuts Required') {
    return `${rootRoute}/collections/lug-nuts`;
  }
};

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  Widgets: [
    ...shopifyGenericDefaults.Widgets,
    {
      name: 'UpsizeDownsizeFacetPanel',
      type: 'FacetPanel',
      fields: ['wheel_tire_diameter'],
      showAllAlways: true,
      disableCollapse: true,
    },
    {
      name: 'WheelTireVehicleInfo',
    },
  ],
};
